var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMobilePhoneBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 16") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "B-&-S-Settings-Hardware-Info-11+",
    transform: "translate(-223, -1745)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-16",
    transform: "translate(223, 1745)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "ViewBox",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.171576,3.171576 C6.92172,2.4214272 7.939136,2 9,2 L23,2 C24.06088,2 25.07832,2.4214272 25.8284,3.171576 C26.57856,3.92172 27,4.939136 27,6 L27,26 C27,27.06088 26.57856,28.07832 25.8284,28.8284 C25.07832,29.57856 24.06088,30 23,30 L9,30 C7.939136,30 6.92172,29.57856 6.171576,28.8284 C5.421428,28.07832 5,27.06088 5,26 L5,6 C5,4.939136 5.421428,3.92172 6.171576,3.171576 Z M9,4 C8.469568,4 7.960856,4.210712 7.585784,4.585784 C7.210712,4.960856 7,5.469568 7,6 L7,26 C7,26.5304 7.210712,27.03912 7.585784,27.41424 C7.960856,27.78928 8.469568,28 9,28 L23,28 C23.5304,28 24.03912,27.78928 24.41424,27.41424 C24.78928,27.03912 25,26.5304 25,26 L25,6 C25,5.469568 24.78928,4.960856 24.41424,4.585784 C24.03912,4.210712 23.5304,4 23,4 L9,4 Z M13,26 C13,25.44768 13.44768,25 14,25 L18,25 C18.55232,25 19,25.44768 19,26 C19,26.55232 18.55232,27 18,27 L14,27 C13.44768,27 13,26.55232 13,26 Z M12.201488,12.54888 C14.59536,10.61392 16.0912,8 16.0912,8 C16.0912,8 18.37792,10.00288 17.04712,12.44704 C16.58296,13.29944 15.61392,14.21232 15.61392,14.21232 C15.61392,14.21232 14.27608,15.4896 13.49808,15.9096 C12.303512,16.55464 9.807592,14.48384 12.201488,12.54888 Z M15.88696,20.67248 C15.88696,20.67248 17.36224,18.01768 19.74672,16.0392 C22.1312,14.06072 19.60264,11.99568 18.40936,12.65928 C17.63232,13.09144 16.30184,14.39496 16.30184,14.39496 C16.30184,14.39496 15.33792,15.32664 14.88056,16.19216 C13.5692,18.67376 15.88696,20.67248 15.88696,20.67248 Z",
    id: "Shape",
    fill: "#192340"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobilePhoneBlack);
export default __webpack_public_path__ + "static/media/mobile-phone-black.662adde80a66d99253ca33612c9dea45.svg";
export { ForwardRef as ReactComponent };